import { Box, Typography } from "@mui/material";

const EmptyPage = ({ title = "" }) => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
        px: 2,
      }}
    >
      {title ? (
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      ) : null}
      <Typography variant="body1" sx={{ color: "text.secondary" }}>
        This page is intentionally left empty for now.
      </Typography>
    </Box>
  );
};

export default EmptyPage;
